/**
 * Appends campaign-tracking UTM parameters to a share link.
 *
 * Every share action — Copy link, post to X, LinkedIn, Slack, etc. — routes through this
 * single helper so each click produces its own tagged URL (rather than one static shared URL)
 * and the tagging scheme stays consistent. Adding a new platform is a one-line change at the
 * call site: pass the new `source`/`medium`.
 *
 * Scheme:
 *   - utm_source:   the specific action (`twitter`, `linkedin`, `slack`, `copy_link`, …)
 *   - utm_medium:   `social` for platform posts, `referral` for a copied link
 *   - utm_campaign: `qa_share` — static for every share action
 *   - utm_content:  `project_overview` — static; the only shareable surface for now
 */
export function buildShareUrl(baseUrl: string, source: string, medium: string): string {
  const url = new URL(baseUrl)
  url.searchParams.set('utm_source', source)
  url.searchParams.set('utm_medium', medium)
  url.searchParams.set('utm_campaign', 'qa_share')
  url.searchParams.set('utm_content', 'project_overview')
  return url.toString()
}
